import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useContext, useMemo } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { ANALYTICS_CHANNEL } from '../../common/constants';
import { useExperience } from '../../common/ui/experience-tracker';
import createEventPayload from '../../common/utils/analytics/analytics.codegen';
import { getErrorType } from '../../common/utils/errors';
var LinkCreateCallbackContext = /*#__PURE__*/React.createContext({});
var LinkCreateCallbackProvider = function LinkCreateCallbackProvider(_ref) {
  var children = _ref.children,
    _onCreate = _ref.onCreate,
    _onFailure = _ref.onFailure,
    onCancel = _ref.onCancel;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var experience = useExperience();
  var handleCreate = useMemo(function () {
    return {
      onCreate: function () {
        var _onCreate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(result) {
          var objectId, objectType;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                /**
                 * We consider the experience successful once we have
                 * successfully created an object
                 */
                experience === null || experience === void 0 || experience.success();
                objectId = result.objectId, objectType = result.objectType;
                createAnalyticsEvent(createEventPayload('track.object.created.linkCreate', {
                  objectId: objectId,
                  objectType: objectType
                })).fire(ANALYTICS_CHANNEL);
                if (!_onCreate) {
                  _context.next = 6;
                  break;
                }
                _context.next = 6;
                return _onCreate(result);
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function onCreate(_x) {
          return _onCreate2.apply(this, arguments);
        }
        return onCreate;
      }()
    };
  }, [createAnalyticsEvent, _onCreate, experience]);
  var handleFailure = useMemo(function () {
    return {
      onFailure: function () {
        var _onFailure2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(error) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                createAnalyticsEvent(createEventPayload('track.object.createFailed.linkCreate', {
                  failureType: getErrorType(error)
                })).fire(ANALYTICS_CHANNEL);
                experience === null || experience === void 0 || experience.failure(error);
                _onFailure && _onFailure(error);
              case 3:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function onFailure(_x2) {
          return _onFailure2.apply(this, arguments);
        }
        return onFailure;
      }()
    };
  }, [createAnalyticsEvent, _onFailure, experience]);
  var value = useMemo(function () {
    return _objectSpread(_objectSpread({
      onCancel: onCancel
    }, handleCreate), handleFailure);
  }, [onCancel, handleCreate, handleFailure]);
  return /*#__PURE__*/React.createElement(LinkCreateCallbackContext.Provider, {
    value: value
  }, children);
};
var useLinkCreateCallback = function useLinkCreateCallback() {
  return useContext(LinkCreateCallbackContext);
};
export { LinkCreateCallbackProvider, useLinkCreateCallback };